import ItemCardAudioContent from './itemCardAudioContent'

export default ItemCardAudioContent
